<template>
	<div class="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
		<div class="text-center">
			<p class="text-base font-semibold text-mabey-600">404</p>
			<h1 class="mt-4 text-3xl font-bold tracking-tight text-mabey-950 sm:text-5xl">
				Page not found
			</h1>
			<p class="mt-6 text-base leading-7 text-gray-600">
				Sorry, we couldn’t find the page you’re looking for.
			</p>
			<div class="mt-6 flex items-center justify-center">
				<app-button
					:to="
						$route.params.notFound && $route.params.notFound[0] == 'yard-app'
							? '/yard-app'
							: '/'
					"
					size="large">
					Dashboard
				</app-button>
			</div>
		</div>
	</div>
</template>
